import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const s = {
  page:   { minHeight:'100vh', background:'#0f172a', display:'flex',
            alignItems:'center', justifyContent:'center' },
  card:   { background:'#1e293b', border:'1px solid #334155', borderRadius:16,
            padding:'40px 36px', width:360 },
  logo:   { fontSize:24, fontWeight:700, color:'#38bdf8', marginBottom:4 },
  sub:    { fontSize:13, color:'#64748b', marginBottom:32 },
  label:  { fontSize:12, color:'#94a3b8', marginBottom:6, display:'block',
            textTransform:'uppercase', letterSpacing:'.5px' },
  input:  { width:'100%', background:'#0f172a', border:'1px solid #334155',
            borderRadius:8, padding:'11px 14px', color:'#f1f5f9', fontSize:14,
            outline:'none', marginBottom:18 },
  btn:    { width:'100%', background:'#0ea5e9', color:'#fff', border:'none',
            borderRadius:8, padding:13, fontSize:14, fontWeight:600,
            cursor:'pointer', marginTop:4 },
  err:    { background:'rgba(239,68,68,.12)', color:'#f87171', borderRadius:8,
            padding:'10px 14px', fontSize:13, marginBottom:16, border:'1px solid rgba(239,68,68,.25)' }
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Falha ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>WaFlow Admin</div>
        <div style={s.sub}>Painel administrativo · Grupo D1</div>
        {error && <div style={s.err}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={email}
            onChange={e => setEmail(e.target.value)} placeholder="admin@grupod1.com.br" required/>
          <label style={s.label}>Senha</label>
          <input style={s.input} type="password" value={password}
            onChange={e => setPassword(e.target.value)} placeholder="••••••••" required/>
          <button style={s.btn} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
